"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeasurementPartnersToJSON = exports.MeasurementPartnersFromJSONTyped = exports.MeasurementPartnersFromJSON = exports.MeasurementPartners = void 0;
/**
 * A combined enum. See individual references for specific partner types.
 * @export
 */
exports.MeasurementPartners = {
    Kochava: 'KOCHAVA',
    Spaa: 'SPAA'
};
function MeasurementPartnersFromJSON(json) {
    return MeasurementPartnersFromJSONTyped(json, false);
}
exports.MeasurementPartnersFromJSON = MeasurementPartnersFromJSON;
function MeasurementPartnersFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.MeasurementPartnersFromJSONTyped = MeasurementPartnersFromJSONTyped;
function MeasurementPartnersToJSON(value) {
    return value;
}
exports.MeasurementPartnersToJSON = MeasurementPartnersToJSON;
